import { Ref } from 'react'

import clsx from 'clsx'

import { ChildProps } from '@/common/util/props'

interface Props extends ChildProps {
  id?: string
  noRadius?: boolean
  noShadow?: boolean
  noBorder?: boolean
  bottomMargin?: 0 | 16 | 24
  tableWrap?: boolean
  bgColor?: 'default' | 'caution' | 'secondary'
  borderColor?: 'success' | 'emphasis' | 'sora'
  ref?: Ref<HTMLDivElement>
}

const Area = ({
  id,
  children,
  noRadius = false,
  noShadow = false,
  noBorder = false,
  bottomMargin = 0,
  tableWrap = false,
  bgColor = 'default',
  borderColor,
  ref
}: Props) => {
  const bottomMarginClass = bottomMargin == 16 ? 'mb-4' : bottomMargin == 24 ? 'mb-6' : ''
  const bgColorClass =
    bgColor === 'caution'
      ? 'bg-surface-caution border border-caution'
      : bgColor === 'secondary'
        ? 'bg-surface-secondary border border-secondary'
        : 'bg-surface'
  const borderColorClass =
    borderColor === 'success'
      ? 'border-success border-3'
      : borderColor === 'emphasis'
        ? 'border-emphasis border-3'
        : borderColor === 'sora'
          ? 'border-3 border-sora-400'
          : 'border-secondary'
  return (
    <div
      id={id}
      ref={ref}
      className={clsx(
        bgColorClass,
        'relative z-auto',
        !noRadius && 'overflow-hidden rounded-xl',
        bottomMarginClass,
        !noBorder && 'border',
        borderColorClass,
        !noShadow && 'shadow-area',
        tableWrap && 'flex min-h-0 min-w-0 flex-1 flex-col'
      )}
    >
      {children}
    </div>
  )
}

export default Area
